const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .icon-notification-new{fill:#008941;stroke:none;stroke-linecap:round;stroke-linejoin:round}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-notification-new",
  d: "M18,33a3.009,3.009,0,0,0,3-3H15A3.009,3.009,0,0,0,18,33Zm9-9V16.5c0-4.6-2.445-8.46-6.75-9.48V6a2.25,2.25,0,0,0-4.5,0V7.02C11.46,8.04,9,11.88,9,16.5V24L6,27v1.5H30V27Zm-3,1.5H12v-9c0-3.72,2.265-6.75,6-6.75s6,3.03,6,6.75Z",
  transform: "translate(-6 -3.75)"
});
function SvgIconfeatherMaterialNotificationsNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 29.25,
    viewBox: "0 0 24 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherMaterialNotificationsNone);
export default __webpack_public_path__ + "static/media/Icon feather-material-notifications-none.c81b8e16.svg";
export { ForwardRef as ReactComponent };